import { render, staticRenderFns } from "./StructureCrud.vue?vue&type=template&id=55294da2&scoped=true"
import script from "./StructureCrud.vue?vue&type=script&lang=js"
export * from "./StructureCrud.vue?vue&type=script&lang=js"
import style0 from "./StructureCrud.vue?vue&type=style&index=0&id=55294da2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55294da2",
  null
  
)

export default component.exports